/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientType } from './RecipientType';
import {
    RecipientTypeFromJSON,
    RecipientTypeFromJSONTyped,
    RecipientTypeToJSON,
    RecipientTypeToJSONTyped,
} from './RecipientType';

/**
 * A recipient of a claim email
 * @export
 * @interface ClaimEmailRecipient
 */
export interface ClaimEmailRecipient {
    /**
     * 
     * @type {number}
     * @memberof ClaimEmailRecipient
     */
    readonly id: number;
    /**
     * ID of the parent claim email
     * @type {number}
     * @memberof ClaimEmailRecipient
     */
    claimEmailId: number;
    /**
     * 
     * @type {RecipientType}
     * @memberof ClaimEmailRecipient
     */
    recipientType: RecipientType;
    /**
     * Recipient email address
     * @type {string}
     * @memberof ClaimEmailRecipient
     */
    email: string;
    /**
     * Recipient display name
     * @type {string}
     * @memberof ClaimEmailRecipient
     */
    name?: string | null;
}



/**
 * Check if a given object implements the ClaimEmailRecipient interface.
 */
export function instanceOfClaimEmailRecipient(value: object): value is ClaimEmailRecipient {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimEmailId' in value) || value['claimEmailId'] === undefined) return false;
    if (!('recipientType' in value) || value['recipientType'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ClaimEmailRecipientFromJSON(json: any): ClaimEmailRecipient {
    return ClaimEmailRecipientFromJSONTyped(json, false);
}

export function ClaimEmailRecipientFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimEmailRecipient {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimEmailId': json['claimEmailId'],
        'recipientType': RecipientTypeFromJSON(json['recipientType']),
        'email': json['email'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function ClaimEmailRecipientToJSON(json: any): ClaimEmailRecipient {
    return ClaimEmailRecipientToJSONTyped(json, false);
}

export function ClaimEmailRecipientToJSONTyped(value?: Omit<ClaimEmailRecipient, 'id'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claimEmailId': value['claimEmailId'],
        'recipientType': RecipientTypeToJSON(value['recipientType']),
        'email': value['email'],
        'name': value['name'],
    };
}

